import { balanceEvaluationPlanWebDocumentA4Layout } from './evaluationPlanWebDocumentA4Layout';

export function prepareEvaluationPlanWebDocumentPageClone(clone: HTMLElement): void {
  clone.style.overflow = 'visible';
  clone.style.boxShadow = 'none';
  clone.style.aspectRatio = '210 / 297';

  const width = clone.offsetWidth || clone.clientWidth || 794;
  if (width > 0) {
    clone.style.width = `${width}px`;
  }

  balanceEvaluationPlanWebDocumentA4Layout(clone);

  clone.querySelectorAll('.cp-evaluation-plan-web-doc-page-main').forEach((el) => {
    const node = el as HTMLElement;
    node.style.overflow = 'visible';
  });

  clone.querySelectorAll('.cp-evaluation-plan-web-doc-example-answer-section').forEach((el) => {
    const node = el as HTMLElement;
    node.style.overflow = 'visible';
  });

  clone.querySelectorAll('.cp-evaluation-plan-web-doc-example-answer-body').forEach((el) => {
    const node = el as HTMLElement;
    node.style.overflow = 'visible';
  });
}

/** @deprecated export-root 래퍼용 — 페이지 단위 클론은 prepareEvaluationPlanWebDocumentPageClone 사용 */
export function prepareEvaluationPlanWebDocumentExportClone(clone: HTMLElement): void {
  const page = clone.querySelector('.cp-evaluation-plan-web-doc-page') as HTMLElement | null;
  if (page) {
    prepareEvaluationPlanWebDocumentPageClone(page);
  }

  clone.style.overflow = 'visible';
  clone.style.maxHeight = 'none';
  clone.style.height = 'auto';
}
